import { useAppDispatch, useAppSelector } from 'app/hooks';
import { setSystemSort } from 'features/ui';
import useIsCompatibilityPathway from 'hooks/use-is-compatibility-pathway';
import { ChangeEvent, useId } from 'react';
import { isSystemSortOption, systemSortOptionsFor } from 'utils/system-sort';

// The ordering control for Choose Systems. On the ducted path it is the
// ONLY one: every option is a server order over the whole candidate pool
// (the priorities panel does not apply there), and the list includes the
// ducted-only cost-of-ownership figure.
export default function SystemSortSelect() {
  const dispatch = useAppDispatch();
  const systemSort = useAppSelector((state) => state.ui.systemSort);
  const isDucted = useIsCompatibilityPathway();
  const selectId = useId();

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    if (isSystemSortOption(value)) dispatch(setSystemSort(value));
  };

  return (
    <div className='flex shrink-0 items-center gap-2'>
      <label
        htmlFor={selectId}
        className='whitespace-nowrap text-sm font-medium text-gray-600'
      >
        Sort by
      </label>
      <select
        id={selectId}
        data-testid='system-sort-select'
        value={systemSort}
        onChange={handleChange}
        className='block cursor-pointer rounded-md border-gray-300 py-1.5 pl-2 pr-8 text-sm shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500'
      >
        {systemSortOptionsFor(isDucted).map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
